// ============================================================
// PageHeader.js
// Page-level header. Title + optional subtitle on the left, CTA
// slot on the right. Used at the top of every authenticated page
// rendered inside <AppShell>.
// ============================================================

import React from 'react';
import './PageHeader.css';

export default function PageHeader({ title, subtitle, cta, breadcrumb }) {
  return (
    <div className="page-header">
      <div className="page-header__text">
        {breadcrumb && <div className="page-header__breadcrumb">{breadcrumb}</div>}
        <h1 className="page-header__title">{title}</h1>
        {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
      </div>
      {cta && <div className="page-header__cta">{cta}</div>}
    </div>
  );
}
